import { useState as d, useEffect as s } from "react";
const r = "youtube-iframe-api-script", a = "https://www.youtube.com/iframe_api";
let o = null, u = null;
const f = () => (o || (o = new Promise((t) => {
  if (u = t, document.getElementById(r))
    if (typeof window.YT < "u" && window.YT.Player) {
      t(!0);
      return;
    } else {
      window.onYouTubeIframeAPIReady = () => {
        t(!0);
      };
      return;
    }
  const e = document.createElement("script");
  e.id = r, e.src = a, e.async = !0, window.onYouTubeIframeAPIReady = () => {
    u && u(!0);
  }, e.onerror = () => {
    u && u(!1), o = null;
  }, document.head.appendChild(e);
})), o);
function l() {
  const [t, e] = d(!1);
  return s(() => {
    let n = !0;
    return f().then((i) => {
      n && e(i);
    }), () => {
      n = !1;
    };
  }, []), t;
}
export {
  l as useYouTubeAPI
};
